/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API47909Req {
  
  /** 任务id */
  taskId?: number;
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  taskStatus?: number;
  /** 反馈 */
  feedback?: string;
  /** 任务转交人用户id */
  taskTransferId?: string;
};



export type API47909Res = {};


// 47909 提交反馈

export interface IUsePostAPI47909Return {
  /** 提交反馈: 接口请求状态 */
  isAPI47909Loading: boolean;
  /** 提交反馈: 接口请求返回数据 */
  dataAPI47909: API47909Res;
  /**  提交反馈: 接口数据请求方法 */
  fetchAPI47909Data:  (inputs: API47909Req, config?: YWRequestConfig) => Promise<API47909Res>;
  /** 提交反馈: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI47909 = ():IUsePostAPI47909Return => {
  let isMount = true;
  const [isAPI47909Loading, setIsAPI47909Loading] = useState(false);
  const [dataAPI47909, setDataAPI47909] = useState<API47909Res>({} as API47909Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/task/submitFeedBack`;

  const fetchAPI47909Data = async (inputs: API47909Req, config?: YWRequestConfig): Promise<API47909Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47909Req>) || {}) as API47909Req;
    
  
    if ( isMount ) {
      setIsAPI47909Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API47909Res>(`${basePath}/corp-admin/project/plan/task/submitFeedBack`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI47909(res || {} as API47909Res);
        setIsAPI47909Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47909Loading(false);
      }
      return false as unknown as API47909Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47909Loading,
    dataAPI47909,
    fetchAPI47909Data,
    requestUrl,
  }
}

